import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/content-destinations/post/stop.ts
var stop_exports = /* @__PURE__ */ __exportAll({
	RequestSchema: () => RequestSchema,
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var PartnerDataSchema = z.object({ facebookPartnerData: z.object({
	crossposts: z.array(z.object({ destinationId: z.string() })),
	destinationId: z.string().optional(),
	thumbnailUploaded: z.boolean().nullish(),
	type: z.enum([
		"yt_create_new",
		"fb_timeline",
		"fb_event",
		"fb_page",
		"fb_group",
		"ig_create_new",
		"tt_create_new"
	]).optional()
}) });
var ContentDestinationSchema = z.object({
	active: z.boolean(),
	airingId: z.string(),
	alignmentOffsetMinutes: z.number(),
	autoArchiveMediaId: z.string().optional(),
	broadcastId: z.string().optional(),
	channelId: z.string().optional(),
	cloudUrlDash: z.string().optional(),
	cloudUrlHls: z.string().optional(),
	contentDestinationScheduleId: z.string().optional(),
	customerId: z.string(),
	dashIngestUrl: z.string().optional(),
	dashPreviewUrl: z.string().optional(),
	description: z.string().optional(),
	embedUrl: z.string().optional(),
	encoderEventId: z.string().optional(),
	hidden: z.boolean(),
	hotspotsId: z.string().optional(),
	id: z.string(),
	imageUrl: z.string().optional(),
	mediaId: z.string().optional(),
	nextSimLive: z.boolean(),
	partnerData: PartnerDataSchema.optional(),
	privacy: z.enum([
		"public",
		"friends_of_friends",
		"all_friends",
		"private",
		"unlisted"
	]).optional(),
	publishStatus: z.enum([
		"created",
		"ready",
		"unpublished",
		"published",
		"scheduled_unpublished",
		"scheduled_published",
		"completed"
	]).optional(),
	published: z.boolean(),
	removeTime: z.string(),
	rtmpDestinationId: z.string().optional(),
	rtmpIngestUrl: z.string().optional(),
	scheduledDurationMillis: z.number().optional(),
	scheduledStartTime: z.string().optional(),
	sourceAlignmentTime: z.string().optional(),
	sourceContentDestinationId: z.string().optional(),
	sourceEventId: z.string().optional(),
	startRequestTime: z.string().optional(),
	startTimeOffsetMillis: z.number(),
	status: z.enum([
		"IDLE",
		"SET_UP",
		"STARTING",
		"STARTED",
		"STOPPING",
		"STOPPED",
		"ABORTED",
		"ERROR"
	]),
	streamType: z.enum([
		"SIMLIVE",
		"LIVE",
		"REPUBLISH",
		"EXISTING_ENCODER_EVENT",
		"EXISTING_MEDIA"
	]),
	title: z.string(),
	type: z.enum([
		"EMBED",
		"FACEBOOK",
		"RSP_SOURCE",
		"SAVEONLY",
		"RTMP",
		"YOUTUBE"
	]),
	viewUrl: z.string().optional(),
	webEncoderProfileId: z.string().optional(),
	webEventProfileId: z.string(),
	webEventProfileName: z.string().optional(),
	webEventProfileType: z.enum([
		"public",
		"return_feed",
		"social"
	])
});
var RequestSchema = z.object({ contentDestinationIds: z.array(z.string()) });
var ResponseSchema = z.array(ContentDestinationSchema);
var parse = parseFactory(ResponseSchema);
//#endregion
export { stop_exports };

//# sourceMappingURL=stop.js.map